import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { pushNotification } from "utils/notifications";
import CauHinhThongKeKhachHangApi from "service/CauHinhThongKeKhachHangApi";

const XoaThuocTinh = ({ tab, data, onClose, onSearch }) => {
    const [deleting, setDeleting] = useState(false);

    const handleConfirm = async () => {
        try {
            setDeleting(true);
            const res = await CauHinhThongKeKhachHangApi.xoa({
                loai: tab.loai,
                id: data.Id,
            });
            if (!res.ok) {
                pushNotification(
                    typeof res.data === "string" && res.data !== ""
                        ? res.data
                        : "Không thể xóa. Vui lòng thử lại!",
                    "error",
                    "TOP_CENTER",
                    2000
                );
                return;
            }
            pushNotification("Xóa thành công!", "success", "TOP_CENTER", 1000);
            onClose();
            onSearch();
        } catch (err) {
            console.error("Lỗi khi xóa:", err);
            pushNotification(
                err?.response?.data || "Không thể xóa. Vui lòng thử lại!",
                "error",
                "TOP_CENTER",
                2000
            );
        } finally {
            setDeleting(false);
        }
    };

    return (
        <Modal
            show={true}
            size="modal-dialog modal-dialog"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className="modal-new modal fade text-left"
        >
            <Modal.Header>
                <h4 className="modal-title">
                    <span className="btn-icon-right">
                        <i className="mdi mdi-delete"></i>
                    </span>
                    Xác nhận xoá
                </h4>
                <button type="button" className="close-popup-new" onClick={onClose}>
                    <i className="mdi mdi-close"></i>
                </button>
            </Modal.Header>
            <Modal.Body>
                <form className="form tat-toan form-horizontal">
                    <div className="form-body">
                        <div className="form-group row">
                            <label className="col-md-12 label-control text-left">
                                Bạn có chắc chắn muốn xóa {tab.tenThuocTinh}{" "}
                                <strong>"{data?.Ten}"</strong> không?
                            </label>
                        </div>
                    </div>
                </form>
            </Modal.Body>
            <Modal.Footer>
                <button
                    type="button"
                    className="btn btn-new-main btn-checknew"
                    disabled={deleting}
                    onClick={handleConfirm}
                >
                    <span className="btn-icon-left">
                        <i className="mdi mdi-check"></i>
                    </span>
                    Xác nhận
                </button>
                <button
                    type="button"
                    className="btn btn-new-main btn-closenew"
                    onClick={onClose}
                >
                    <span className="btn-icon-left">
                        <i className="mdi mdi-close"></i>
                    </span>
                    Đóng
                </button>
            </Modal.Footer>
        </Modal>
    );
};

export default XoaThuocTinh;
